import React from 'react'
import { Box, Skeleton } from '@mui/material'

const SkeletonChart = () => {
    return (
        <Box sx={{ width: '100%', height: 400, p: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', height: '100%' }}>
                {[...Array(8)].map((_, index) => (
                    <Box key={index} sx={{ flex: 1, mx: 1 }}>
                        <Skeleton
                            variant="rectangular"
                            height={Math.random() * 120 + 40}
                            animation="wave"
                            sx={{ borderRadius: 1 }}
                        />
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default SkeletonChart